export const ChevronRightIcon = ({ width = 5, height = 7, color = "#212529", ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M0 6.1775L2.67167 3.5L0 0.8225L0.8225 0L4.3225 3.5L0.8225 7L0 6.1775Z" fill={color} />
        </svg>
    );
}; 